/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  // Saludo obligatorio cliente nuevo (Victor 2026-05-24): pregunta al backend si
  // corresponde precargar el saludo en el cuadro para esta conversación.
  newClientGreeting(conversationID) {
    return axios.get(`${this.url}/${conversationID}/new_client_greeting`);
  }

  // Presentación obligatoria del rol Fotógrafo / Video (Victor 2026-06-07):
  // pregunta si hay que mostrar la tarjeta de presentación + el texto fijo.
  photographerPresentation(conversationID) {
    return axios.get(`${this.url}/${conversationID}/photographer_presentation`);
  }

  // Envía el saludo de presentación fijo y sella al cliente (una sola vez total).
  sendPhotographerPresentation(conversationID) {
    return axios.post(`${this.url}/${conversationID}/photographer_presentation`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  show(conversationID) {
    return axios.get(`${this.url}/${conversationID}`);
  }

  // Historial completo del cliente (Victor 2026-06-03): todos los mensajes de
  // todas sus conversaciones (misma sucursal), en orden. Solo lectura.
  fullHistory(conversationID) {
    return axios.get(`${this.url}/${conversationID}/full_history`);
  }

  getMessages(conversationID, { before } = {}) {
    const params = before ? { before } : {};
    return axios.get(`${this.url}/${conversationID}/messages`, { params });
  }

  sendMessage(conversationID, { content, isPrivate = false } = {}) {
    return axios.post(`${this.url}/${conversationID}/messages`, {
      content,
      private: isPrivate,
    });
  }
}

export default new ConversationApi();
